import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import axios from "axios";
import { API } from "../context/AuthContext";

export default function Knowledge() {
    const { slug } = useParams();
    const [articles, setArticles] = useState([]);
    const [article, setArticle] = useState(null);

    useEffect(() => {
        axios.get(`${API}/knowledge`).then((r) => setArticles(r.data.articles));
    }, []);

    useEffect(() => {
        if (slug) {
            axios.get(`${API}/knowledge/${slug}`).then((r) => setArticle(r.data));
        } else {
            setArticle(null);
        }
    }, [slug]);

    if (slug && article) {
        return (
            <>
                <Navbar />
                <main className="min-h-screen pt-28 pb-12 px-6">
                    <div className="max-w-3xl mx-auto">
                        <Link to="/knowledge" className="text-muted text-sm hover:text-gold" data-testid="back-to-kb">← All Wisdom</Link>
                        <p className="label-tracking text-gold mt-6">{article.category}</p>
                        <h1 className="font-serif text-5xl mt-2">{article.title}</h1>
                        <p className="font-serif text-lg leading-relaxed text-muted mt-8" data-testid="article-content">
                            {article.content}
                        </p>
                    </div>
                </main>
            </>
        );
    }

    const groups = articles.reduce((acc, a) => {
        (acc[a.category] = acc[a.category] || []).push(a);
        return acc;
    }, {});

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-5xl mx-auto">
                    <p className="label-tracking text-gold">The Library</p>
                    <h1 className="font-serif text-5xl mt-2">Ancient Wisdom</h1>
                    <p className="text-muted mt-3 max-w-xl font-serif italic">
                        A guide to the symbols, planets, and patterns that have shaped human destiny for millennia.
                    </p>

                    {Object.entries(groups).map(([cat, items]) => (
                        <section key={cat} className="mt-10">
                            <h2 className="font-serif text-3xl text-gold">{cat}</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                {items.map((a) => (
                                    <Link
                                        key={a.slug}
                                        to={`/knowledge/${a.slug}`}
                                        className="glass hover-lift p-6 block"
                                        data-testid={`kb-article-${a.slug}`}
                                    >
                                        <h3 className="font-serif text-2xl">{a.title}</h3>
                                        <p className="text-sm text-muted mt-2 line-clamp-2">{a.content.substring(0, 120)}...</p>
                                        <p className="text-xs text-gold mt-3 label-tracking">Read more →</p>
                                    </Link>
                                ))}
                            </div>
                        </section>
                    ))}
                </div>
            </main>
        </>
    );
}
